import { render, staticRenderFns } from "./passwordChangeDialog.vue?vue&type=template&id=227946d2"
import script from "./passwordChangeDialog.vue?vue&type=script&lang=js"
export * from "./passwordChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./passwordChangeDialog.vue?vue&type=style&index=0&id=227946d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports